import { Select } from "melco-ui";
import styled from "styled-components";
import { useAssignUnassignProducts } from "../../hooks/users/useAssignUnassignProducts";

type UserProductsSelectProps = {
  onChange: (value: string) => void;
  value?: string;
  userId?: string;
  defaultLoading?: (value: string) => void;
};
let _default: string | null | undefined;
const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const UserProductsSelect: React.FC<UserProductsSelectProps> = ({
  value,
  onChange,
  defaultLoading
}) => {
  //const { t } = useTranslation();
  const { products } = useAssignUnassignProducts();


  const userProductsOptions = products?.map(
    (userProduct: any) => ({
      value: userProduct.code,
      label: userProduct.name,
    })
  );

  // Initially when page get load no value is selected, select first value as default  
  if (value === undefined && userProductsOptions !== undefined && userProductsOptions.length > 0) {
    _default = userProductsOptions[0].value;

    if (_default !== undefined && _default !== null) {

      if (defaultLoading) {

        defaultLoading(_default);
      }
    }
  }

  else if (value !== undefined && userProductsOptions !== undefined && userProductsOptions.length > 0) {
    // When user selects some value from Products DropDown
    _default = value;

    if (_default !== undefined && _default !== null) {

      if (defaultLoading) {

        defaultLoading(_default);
      }
    }
  }

  else {
    // When there is no product is assigned to user
    if (defaultLoading) {
      _default = ""
      defaultLoading(_default);

    }
  }

  return (
    <SelectBoxWrapper>
      {userProductsOptions && <Select
        allowClear
        placeholder={"Select Product"}
        style={{ width: "100%", minWidth: 150 }}
        maxTagCount={1}
        options={userProductsOptions}
        onChange={onChange}
        value={value !== undefined ? value : _default}
      />}
    </SelectBoxWrapper>
  );
};
